
export default {
  download: 'ดาวน์โหลด',
}
